/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v1/events": {
    post: {
      parameters: {
        header: {
          /** Индикатор того, одно или несколько событий шлем. Если bulk то в запросе payload будет массив событий, single - одно событие */
          "X-Action"?: "bulk" | "single";
        };
      };
      responses: {
        /** Success response */
        200: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
        /** Error Response */
        400: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
        /** Error Response */
        422: {
          content: {
            "application/json": components["schemas"]["EventResponse"];
          };
        };
      };
      requestBody: components["requestBodies"]["EventInput"];
    };
  };
  "/api/auth/login": {
    post: {
      responses: {
        /** Success or wait next steps with 2fa */
        204: never;
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Permission denied if user was blocked or if user isn't admin and try login to admin */
        403: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Many requests */
        419: unknown;
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["LoginInput"];
    };
  };
  "/api/auth/signin": {
    post: {
      responses: {
        /** Success or wait next steps with 2fa */
        204: never;
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Permission denied if user was blocked or if user isn't admin and try login to admin */
        403: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Many requests */
        419: unknown;
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["SignInInput"];
    };
  };
  "/api/auth/is-authorized": {
    get: {
      responses: {
        /** get user auth status */
        200: {
          content: {
            "application/json": components["schemas"]["_api_auth_is_authorized_get_200_response"];
          };
        };
        /** Many requests */
        419: unknown;
      };
    };
  };
  "/api/auth/logout": {
    get: {
      responses: {
        /** redirect on success */
        301: never;
        /** UnauthorizedHttpError */
        401: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Many requests */
        419: unknown;
      };
    };
  };
  "/api/auth/signout": {
    post: {
      responses: {
        /** redirect on success */
        301: never;
        /** UnauthorizedHttpError */
        401: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Many requests */
        419: unknown;
      };
    };
  };
  "/api/auth/login-as/{id}": {
    /** login as in user card */
    get: {
      parameters: {
        path: {
          /** user id */
          id: number;
        };
        query: {
          /** site id */
          siteId: number;
        };
      };
      responses: {
        /** redirect on success */
        301: never;
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** UnauthorizedHttpError */
        401: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Many requests */
        419: unknown;
        /** InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
  };
  "/api/auth/login-by-token/{token}": {
    /** auth by token, used for login-as flow in user card */
    get: operations["AuthLoginByToken"];
  };
  "/api/auth/login-by-transfer-token/{token}": {
    /** auth by token, used for Affstore transfer flow */
    get: operations["AuthLoginByTransferToken"];
  };
  "/api/auth/2fa": {
    get: {
      responses: {
        /** Return status 2fa in body as raw boolean. Return empty body (false), when 2fa is disabled */
        200: {
          content: {
            "application/json": boolean;
          };
        };
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
  };
  "/api/auth/2fa/{id}": {
    get: {
      parameters: {
        path: {
          /** The id of the user */
          id: number;
        };
      };
      responses: {
        /** Return status 2fa in body as raw boolean. Return empty body (false), when 2fa is disabled */
        200: {
          content: {
            "application/json": boolean;
          };
        };
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
  };
  "/api/auth/2fa/init": {
    post: {
      responses: {
        /** Return QR code and secret code for Two-factor apps */
        200: {
          content: {
            "application/json": components["schemas"]["_api_auth_2fa_init_post_200_response"];
          };
        };
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["2FaInitInput"];
    };
  };
  "/api/auth/2fa/enable": {
    post: {
      responses: {
        /** Success. No content */
        200: unknown;
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["2FaInitInput"];
    };
  };
  "/api/auth/2fa/disable": {
    post: {
      responses: {
        /** Success. No content */
        204: never;
        /** Bad Request */
        400: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["2FaDisableInput"];
    };
  };
  "/api/auth/2fa/disable/{id}": {
    post: operations["Auth2faDisableById"];
  };
  "/api/auth/2fa/confirm": {
    post: {
      responses: {
        /** Successful auth */
        204: never;
        /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
        500: {
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
      requestBody: components["requestBodies"]["2FaConfirm"];
    };
  };
}

export interface components {
  schemas: {
    "2FaInitInput": {
      /** @example 11997@mailinator.com */
      email: string;
      /** @example Test1251 */
      password: string;
      /** @example 6 */
      siteId: number;
    };
    "2FaEnableInput": {
      /**
       * @description code as string
       * @example 288770
       */
      code: string;
    };
    "2FaConfirm": {
      /**
       * @description code as string
       * @example 288770
       */
      code: string;
    };
    "2FaDisableInput": {
      /** @example 11997@mailinator.com */
      email: string;
      /** @example Test1251 */
      password: string;
      /** @example 6 */
      siteId: number;
    };
    LoginInput: {
      /** @example john@email.local */
      email: string;
      /** @example Test1251 */
      password: string;
      /** @example 10 */
      siteId: number;
      /**
       * @description marketing track, which added to links in newsletter
       * @example aff_news_track
       */
      retentionTrack?: string;
    };
    SignInInput: {
      /** @example john@email.local */
      email: string;
      /** @example Test1251 */
      password: string;
      /** @example site_name */
      site: string;
      /**
       * @description marketing track, which added to links in newsletter
       * @example aff_news_track
       */
      retentionTrack?: string;
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "common": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    /** @enum {string} */
    EnumUserStatus: "not_confirmed" | "confirmed" | "banned";
    EventResponse:
      | components["schemas"]["EventResponseItem"]
      | components["schemas"]["EventResponseItem"][];
    EventResponseItem: {
      /** @example 200 */
      code?: number;
      errors?: components["schemas"]["EventResponseItem_errors"];
    };
    _api_v1_events_post_request: {
      /**
       * @description Event Name
       * @example event_name
       */
      name: string;
      /** @example 73b3678c-e9c1-4845-897f-4d3f01b08816 */
      device_id: string;
      /** @example text_changed */
      category: string;
      /** @example 2 */
      platform_id: number;
      /** @example 3.0.2 */
      app_version?: string;
      /** @description Относится данное событие к техническому или бизнесовому событию */
      technical_logs?: boolean;
      /** @example {"key":"val", "key2": 2, "key3": true} */
      parameters?: { [key: string]: string };
      /** Format: float */
      value?: number;
      /**
       * Format: int64
       * @description серверное время (на серверах MS Events), когда производилась обработка поступившего от клиента ивента/батча ивентов это поле проставляет data platform при обработке ивента. UNIX (GMT)
       * @example 1488383103000
       */
      server_time?: number;
      /**
       * Format: int64
       * @description системное время (устройства) в миллисекундах в момент события, которое описывает. Может быть некорректным. UNIX (GMT)
       * @example 1488383102666
       */
      client_time?: number;
      /**
       * Format: int64
       * @description время сервера в миллисекундах в момент события, которое описывает (используется для аналитики
       * @example 1488383102666
       */
      sync_time?: number;
      /**
       * Format: uuid
       * @description UUID генерируется для каждого уникального ивента, переиспользуется при повторной отправке, чтобы избежать дубликатов при обработке
       * @example 123e4567-e89b-12d3-a456-426655440000
       */
      uuid?: string;
    };
    _api_auth_is_authorized_get_200_response: boolean | string;
    /**
     * @example {
     *   "secretCode": "GJSFKOTGKRUHSQL3KIYU6TKRHRKEM7LN",
     *   "qrCode": "data:image/png;base64,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"
     * }
     */
    _api_auth_2fa_init_post_200_response: {
      /** @example GJSFKOTGKRUHSQL3KIYU6TKRHRKEM7LN */
      secretCode?: string;
      /**
       * @description qr code image as string
       * @example data:image/png;base64,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
       */
      qrCode?: string;
    };
    EventResponseItem_errors: string | { [key: string]: string };
  };
  requestBodies: {
    "2FaInitInput": {
      content: {
        "application/json": components["schemas"]["2FaInitInput"];
      };
    };
    "2FaEnableInput": {
      content: {
        "application/json": components["schemas"]["2FaEnableInput"];
      };
    };
    "2FaDisableInput": {
      content: {
        "application/json": components["schemas"]["2FaDisableInput"];
      };
    };
    "2FaConfirm": {
      content: {
        "application/json": components["schemas"]["2FaConfirm"];
      };
    };
    LoginInput: {
      content: {
        "application/x-www-form-urlencoded": components["schemas"]["LoginInput"];
      };
    };
    SignInInput: {
      content: {
        "application/x-www-form-urlencoded": components["schemas"]["SignInInput"];
      };
    };
    EventInput: {
      content: {
        "application/json": components["schemas"]["_api_v1_events_post_request"];
      };
    };
  };
}

export interface operations {
  /** auth by token, used for login-as flow in user card */
  AuthLoginByToken: {
    parameters: {
      path: {
        /** token */
        token: string;
      };
    };
    responses: {
      /** redirect on success */
      301: never;
      /** Bad Request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Many requests */
      419: unknown;
      /** InternalServerHttpError */
      500: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** auth by token, used for Affstore transfer flow */
  AuthLoginByTransferToken: {
    parameters: {
      path: {
        /** token */
        token: string;
      };
    };
    responses: {
      /** redirect on success */
      301: never;
      /** Bad Request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Many requests */
      419: unknown;
      /** InternalServerHttpError */
      500: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  Auth2faDisableById: {
    parameters: {
      path: {
        /** The id of the user */
        id: number;
      };
    };
    responses: {
      /** Success. No content */
      204: never;
      /** Bad Request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error (form-reg.common-error) or InternalServerHttpError */
      500: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["2FaDisableInput"];
  };
}

export interface external {}

export enum ApiPaths {
  PostApiV1Events = "/api/v1/events",
  PostApiAuthLogin = "/api/auth/login",
  PostApiAuthSignin = "/api/auth/signin",
  GetApiAuthIsauthorized = "/api/auth/is-authorized",
  GetApiAuthLogout = "/api/auth/logout",
  PostApiAuthSignout = "/api/auth/signout",
  GetApiAuthLoginas = "/api/auth/login-as/:id",
  AuthLoginByToken = "/api/auth/login-by-token/:token",
  AuthLoginByTransferToken = "/api/auth/login-by-transfer-token/:token",
  GetApiAuth2fa = "/api/auth/2fa",
  GetApiAuth2fa10 = "/api/auth/2fa/:id",
  PostApiAuth2faInit = "/api/auth/2fa/init",
  PostApiAuth2faEnable = "/api/auth/2fa/enable",
  PostApiAuth2faDisable = "/api/auth/2fa/disable",
  Auth2faDisableById = "/api/auth/2fa/disable/:id",
  PostApiAuth2faConfirm = "/api/auth/2fa/confirm",
}
